import React from "react";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  textAlign: "center",
};

const thTdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

const headerStyle = {
  backgroundColor: "#f2f2f2",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1,
};

const PivotTable = ({ data }) => {
  if (!data || data.length === 0) return <p>No data available</p>;

  const dateColumns = Object.keys(data[0]).filter((key) => key !== "mrnNumber");

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...headerStyle }}>MRN</th>
            {dateColumns.map((date) => (
              <th key={date} style={{ ...thTdStyle, ...headerStyle }}>
                {date.replaceAll("_", "/")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}>
              <td style={thTdStyle}>{row.mrnNumber}</td>
              {dateColumns.map((date) => (
                <td key={date} style={thTdStyle}>{row[date] || ""}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PivotTable;
